







































































































































import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import MemberDetailDrawer from '@/components/member/memberList/memberEditDrawer/MemberEditDrawerBase.vue';
import AccountIcon from '@/components/common/AccountIcon.vue';
import { ProjectMemberResponse } from '@/@types/ProjectMember';
import { vxm } from '@/store';
import { Account } from '@/@types/Account';

@Component({
  components: {
    MemberDetailDrawer,
    AccountIcon,
  },
})
export default class AccountListCard extends Vue {
  @Prop({ required: true })
  private editMode = false;

  @Prop({ required: true })
  private projectMembers!: ProjectMemberResponse[];

  private isOpenMemberDetailDrawer: boolean = false;
  private isMiniMemberEditDrawer: boolean = false;
  private selectedAccount: Account | null = null;
  private selectedProjectMember: ProjectMemberResponse | null = null;

  @Emit('openLeaveMemberModal')
  private openLeaveMemberModal(projectMemberId: number, accountName: string) {
    return { projectMemberId, accountName };
  }

  private closeMemberDetailDrawer(): void {
    this.isOpenMemberDetailDrawer = false;
    this.isMiniMemberEditDrawer = false;
  }

  private async openDrawer(member: ProjectMemberResponse) {
    const accountId = member.accountId;
    await vxm.theoryApi.accountsStore.fetchAccountDetail(accountId);
    this.selectedAccount = vxm.theoryApi.accountsStore.getAccountDetail?.results ?? null;
    this.selectedProjectMember = member;
    this.isOpenMemberDetailDrawer = true;
    this.isMiniMemberEditDrawer = false;
  }

  private miniMemberEditDrawer(): void {
    this.isMiniMemberEditDrawer = true;
    this.isOpenMemberDetailDrawer = true;
  }

  private memberCardColor(leavingFlag: boolean): string {
    return leavingFlag ? 'grey lighten-1' : '';
  }

  private get style(): '450px' | '3.5%' | '0%' {
    if (this.isOpenMemberDetailDrawer && !this.isMiniMemberEditDrawer) {
      return '450px';
    } else if (this.isOpenMemberDetailDrawer && this.isMiniMemberEditDrawer) {
      return '3.5%';
    } else {
      return '0%';
    }
  }
}
